var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-cell"},[_c('div',{staticClass:"font-h6-medium fz-12"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row.belong_text)))]),_c('div',{staticClass:"font-h6-medium fz-12 yx-color-text-regular"},[_vm._v("归属时间："+_vm._s(_vm._f("formatEmpty")(_vm.row.belong_time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }